import React, { useState, useRef, useEffect } from "react";
import VoiceChat from "./VoiceChat";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { SynthesisResult } from "microsoft-cognitiveservices-speech-sdk";

declare global {
  interface Window {
    ccOS: any;
  }
}

export type ChatType = {
  content: string;
  type: string;
  data: any;
  state: string; // init: 시작 / chat: 일반 / store: 매장 선택 / menu: 메뉴 선택 / pay: 결제중 / payment: 결제완료 / confirm: 다음 채팅 X
};

const speechsdk = require("microsoft-cognitiveservices-speech-sdk");

export const SEARCH_CATEGORY = {
  // 1: 블로그 2: 뉴스 3: 책 4: 백과사전 5: 카페글 6: 지식인 7: 지역 8: 웹문서 9: 쇼핑 10: 전문자료
  ALL: 999,
  NEWS: 2,
  DICTIONARY: 4,
  BLOG: 1,
  BOOK: 3,
  CAFE: 5,
  EGGHEAD: 6,
  REGION: 7,
  WEB_DOC: 8,
  SHOPPING: 9,
  PROFESSIONAL: 10,
};

let timeout: any = null;

const Recorder: React.FC = () => {
  // STT / TTS
  const [chat, setChat] = useState<ChatType | null>(null); // 대화내용
  const [chatData, setChatData] = useState<any>(null); // 대화 data

  const [isLoading, setIsLoading] = useState<boolean>(false); // 데이터 로딩

  const [isChat, setIsChat] = useState<boolean>(false); // 채팅 여부
  const [recognizerMode, setRecognizerMode] = useState<boolean>(false); // 녹음 여부
  const [vrState, setVRState] = useState<string>(""); // 현재 stt state
  const [isPlaying, setIsPlaying] = useState<boolean>(false); // 재생여부
  const [playIndex, setPlayIndex] = useState<number>(0); // data index

  // const [prompt, setPrompt] = useState<string>(""); // STT result
  const [log, setLog] = useState<string>(""); // log
  const [vrInstance, setVrInstance] = useState<any>(null); // sttInstance

  const [lastTouchTime, setLastTouchTime] = useState<number>(0); // click Event

  const handleClick = () => {
    const currentTime = new Date().getTime();
    if (currentTime - lastTouchTime > 300) {
      resetSearchBar();
      return;
    } else {
      onClickSearchBar();
    }
    setLastTouchTime(0);
  };

  const clearAudio = () => {
    setIsPlaying(false);
  };

  const resetSearchBar = () => {
    console.log("reset");
    setChat(null);
    setChatData(null);
    setPlayIndex(0);
    setIsPlaying(false);
    setIsLoading(false);
    setRecognizerMode(false);
    setIsChat(true);
    clearAudio();
    setChat({
      content: "무엇을 도와 드릴까요?",
      type: "bot",
      data: null,
      state: "init",
    });
    // setVRState("idle");
    // if (vrState === "idle" && recognizerMode) {
    //   // restart STT
    //   vrInstance && vrInstance.start();
    // }
  };

  const onClickSearchBar = () => {
    clearAudio();
    setRecognizerMode(false);
    setPlayIndex(0);
    setVRState("idle");
    setRecognizerMode(true);
    // if (vrState === "idle" && recognizerMode) {
    // restart STT
    // vrInstance && vrInstance.start();
    // }
  };

  const onVRStateChange = (event: any) => {
    const state = event.detail["state"];
    // setIsLoading(true);
    setIsLoading(false);
    setVRState(state);
  };
  const onVRResultChange = (event: any) => {
    setRecognizerMode(false);
    // setIsLoading(false);

    const result = event.detail["result"];
    setChat({
      content: result,
      type: "user",
      data: null,
      state: chat !== null && chat.data !== null ? "chat" : "ai",
    });
  };

  // chat
  const hasChatResult = async () => {
    if (chat !== null) {
      if (chat.type === "bot" || chat.state === "init") {
        console.log("chat", chat);
        clearAudio();
        playChatTTS();
      }
    } else {
      clearAudio();
    }
  };

  const playChatTTS = () => {
    if (!isLoading && chat !== null) {
      const speechConfig = speechsdk.SpeechConfig.fromSubscription(
        process.env.REACT_APP_AZURE_KEY,
        process.env.REACT_APP_AZURE_REGION
      );
      speechConfig.speechSynthesisVoiceName = "ko-KR-YuJinNeural";

      const audioConfig = speechsdk.AudioConfig.fromDefaultSpeakerOutput();
      const synthesizer = new speechsdk.SpeechSynthesizer(
        speechConfig,
        audioConfig
      );

      const ssml = `
      <speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xml:lang="en-US">
        <voice name="${speechConfig.speechSynthesisVoiceName}">
          <prosody rate="1.2">
            ${chat.content}
          </prosody>
        </voice>
      </speak>
    `;

      synthesizer.speakSsmlAsync(
        ssml,
        (result: SynthesisResult) => {
          console.log("result", result);
          if (
            result.reason === speechsdk.ResultReason.SynthesizingAudioCompleted
          ) {
            timeout = setTimeout(() => {
              console.log("end");
              onChatAudioEnded();
              synthesizer.close();
            }, chat.content.length * 190);
          }
          // setIsSpeaking(false);
          // synthesizer.close();
        },
        (error: string) => {
          console.error(error);
          synthesizer.close();
        }
      );
    }
  };

  const onChatAudioEnded = () => {
    if (chat !== null) {
      console.log("audio end");
      if (
        chat.state !== "confirm" &&
        chat.state !== "pay" &&
        chat.state !== "payment"
      ) {
        setRecognizerMode(true);
      }
    } else {
      clearAudio();
    }
  };

  // test

  useEffect(() => {
    hasChatResult();
    clearTimeout(timeout);
  }, [chat]);

  useEffect(() => {
    if (!isChat) {
      setChat(null);
      setIsPlaying(false);
      setVRState("");
      setRecognizerMode(false);
      // setPrompt("");
      setPlayIndex(0);
      vrInstance && vrInstance.stop();
    }
  }, [isChat]);

  useEffect(() => {
    if (recognizerMode) {
      clearAudio();
      setLog("vr start~~~~~~~~~~");
      vrInstance && vrInstance.start();
    } else {
      setLog("vr stop~~~~~~~~~~~");
      vrInstance && vrInstance.stop();
    }
  }, [recognizerMode]);

  useEffect(() => {
    setLog(log + "\n vrState:" + vrState);
    if (vrState === "error") {
      vrInstance && vrInstance.stop();
      setRecognizerMode(false);
    }
  }, [vrState]);

  // ccos STT init
  useEffect(() => {
    if (window.ccOS) {
      window.ccOS.VoiceRecognizer.getInstance().then((instance: any) => {
        setVrInstance(instance);
        setLog("success connection");
      });
    }
    return () => {
      vrInstance && vrInstance.stop();
    };
  }, []);

  // ccos STT instance init
  useEffect(() => {
    if (vrInstance !== null) {
      // setPrompt("EventListener");
      vrInstance.addEventListener("statechange", onVRStateChange);
      vrInstance.addEventListener("resultchange", onVRResultChange);
    }
  }, [vrInstance]);

  return (
    <Style>
      <VoiceChat
        chat={chat}
        setChat={setChat}
        recognizerMode={recognizerMode}
        setRecognizerMode={setRecognizerMode}
        setIsChat={setIsChat}
        chatData={chatData}
        setChatData={setChatData}
        setPlayIndex={setPlayIndex}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      <button
        className="voice stt"
        onTouchStart={() => setLastTouchTime(new Date().getTime())}
        onTouchEnd={handleClick}
      >
        <img
          src={`${process.env.PUBLIC_URL}/svg/ic_voice.svg`}
          alt="음성인식 아이콘"
          width="100%"
          height="100%"
        />
      </button>
    </Style>
  );
};

export default Recorder;

const Style = styled.div`
  div.stt {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1000000000;

    h1 {
      color: red;
    }
  }

  button.voice.stt {
    z-index: 100;
    height: 14%;
    aspect-ratio: 1/1;
    border-radius: 100%;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 6.5%;
    background: linear-gradient(180deg, #fb69ef 0%, #2a5ec4 86%);

    img {
      width: 50%;
      height: 50%;
    }
  }
`;
